import React from 'react'
import { Collection as CollectionInterface } from '~/domain/Collection'
import { NftCollection } from '~/components/NftCollection'
import styles from './index.module.scss'

interface SeriesCollectionsProps {
  collections: CollectionInterface[]
}

export const SeriesCollections: React.FC<SeriesCollectionsProps> = ({ collections }) => {
  const nftsPerPage = 8
  const seriesCollections = collections.map((collection) => {
    return (
      <NftCollection
        key={ collection.contract.address }
        nftsPerPage={ nftsPerPage }
        collection={ collection }
      />
    )
  })

  return (
    <div 
      data-testid="series-collections"
      className={ styles['series-collections__container'] }
    >
      <h1 className={ styles['series-collections__title'] }>
        Items
      </h1>

      { seriesCollections }
    </div>
  )
}
